import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const UpdatePasswordService = (
  currentPassword: string,
  newPassword: string
) => {
  return HTTP_CLIENT.post(`${Endpoint.settings.updatePassword}`, {
    currentPassword: currentPassword,
    newPassword: newPassword,
  });
};

export { UpdatePasswordService };
